import { useEffect, useRef } from 'react';

import { useQuery } from '@tanstack/react-query';

import { airesFilesIsEmptyQuery, uiStatusQuery } from '@/query';

type Options = {
  isActive: boolean;
  hasSeenTutorial: boolean;
  startTutorial: () => void;
};

export const useTutorialAutoStart = ({ isActive, hasSeenTutorial, startTutorial }: Options) => {
  const { data } = useQuery(airesFilesIsEmptyQuery());
  const { data: uiStatusData } = useQuery(uiStatusQuery());
  const hasFiredRef = useRef(false);

  useEffect(() => {
    if (isActive || hasSeenTutorial || hasFiredRef.current) return;
    if (data?.result?.isEmpty !== false) return;
    if (uiStatusData?.result?.isPassed !== false) return;

    hasFiredRef.current = true;
    startTutorial();
  }, [isActive, hasSeenTutorial, data?.result?.isEmpty, uiStatusData?.result?.isPassed, startTutorial]);
};
